module.exports = __webpack_public_path__ + "img/theme_sidemenu.ea501123.svg";